import { useEffect, useState } from 'react'
import MuiBox from '@mui/material/Box'
import { useFormik, Form, FormikProvider } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../../components/formik-control'
import { useAddFieldToSectionMutation, useUpdateFieldInSectionMutation } from '../../../slice'
import { useGetFieldsQuery } from '../../../../../services/fields/slice'
import LoadingScreen from '../../../../../components/loading-screen'

const FieldForm = ({ campaign, section, field, onSubmitEvent, setSubmitEvent, setShowDrawer }) => {
  const [addFieldToSection] = useAddFieldToSectionMutation()
  const [updateFieldInSection] = useUpdateFieldInSectionMutation()
  const { data: fields } = useGetFieldsQuery(section?.entity ?? 'prospects')
  const [fieldOptions, setFieldOptions] = useState([])
  const [isReadOnlyField, setIsReadOnlyField] = useState(false)

  const initialValues = {
    id: field?.id,
    name: field?.name ?? '',
    entity: section?.entity ?? 'prospects',
    priority: field?.priority ?? 100,
    isReadOnly: field?.readOnly ?? false,
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Required'),
    priority: Yup.number().required('Required'),
    isReadOnly: Yup.boolean(),
  })

  useEffect(() => {
    // TODO: Remove isAdminOnly fields from the list
    if (fields) {
      const fieldOptions = fields
        .filter((field) => field.isAdminOnly !== true)
        .map((field) => {
          return {
            value: field.name,
            key: field.label,
          }
        })
        .sort((a, b) => a.key.localeCompare(b.key))
      setFieldOptions(fieldOptions)
    }
  }, [fields])

  const onSubmit = async (values) => {
    if (values.id)
      await updateFieldInSection({
        campaignId: campaign.id,
        sectionId: section.id,
        fieldId: values.id,
        field: {
          ...values,
          priority: parseInt(values.priority),
        },
      })
    else
      await addFieldToSection({
        campaignId: campaign.id,
        sectionId: section.id,
        field: {
          ...values,
          priority: parseInt(values.priority),
        },
      })
    setSubmitEvent()
    setShowDrawer(false)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(() => {
    if (onSubmitEvent) {
      formik.handleSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSubmitEvent])

  const onFieldNameChange = (e) => {
    if (e.target.name === 'name') {
      const field = fields.find((field) => field.name === e.target.value)
      const isReadOnly = field?.isReadOnly ?? false
      setIsReadOnlyField(isReadOnly)
      if (isReadOnly) formik.setFieldValue('isReadOnly', true)
    }
    formik.handleChange(e)
  }

  if (!fieldOptions.length)
    return (
      <div>
        <LoadingScreen width="100%" height="100%" />
      </div>
    )

  return (
    <FormikProvider value={formik}>
      <Form>
        <MuiBox>
          <FormikControl
            control="select"
            label="Name"
            name="name"
            options={fieldOptions}
            onChange={onFieldNameChange}
          />
        </MuiBox>
        <MuiBox>
          <FormikControl control="input" label="Priority" name="priority" />
        </MuiBox>
        <MuiBox>
          <FormikControl control="checkbox" label="Read Only" name="isReadOnly" disabled={isReadOnlyField} />
        </MuiBox>
      </Form>
    </FormikProvider>
  )
}

export default FieldForm
